module.exports = __webpack_public_path__ + "img/about-zainiac-banner-1200X950.661d75be.png";